import styled, { css } from 'styled-components';

import { Container } from '@/components/Container';
import { NextImage } from '@/components/NextImage';

export const Content = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Image = styled(NextImage)`
  ${({ theme }) => css`
    margin: 0 auto ${theme.spacing(3)};
  `}
`;
